import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const KEY = "kts_compare";
const MAX = 3;
const CompareContext = createContext(null);

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]").slice(0, MAX); } catch { return []; } };

export const CompareProvider = ({ children }) => {
  const [ids, setIds] = useState(read);
  const [notice, setNotice] = useState("");
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);

  const toggle = useCallback((id) => {
    setIds((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= MAX) { setNotice(`Maximum ${MAX} pièces à comparer`); setTimeout(() => setNotice(""), 2000); return prev; }
      return [...prev, id];
    });
  }, []);
  const remove = useCallback((id) => setIds((prev) => prev.filter((x) => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);

  return <CompareContext.Provider value={{ ids, has: (id) => ids.includes(id), toggle, remove, clear, max: MAX, notice }}>{children}</CompareContext.Provider>;
};

export const useCompare = () => useContext(CompareContext);
